import { Component, inject } from '@angular/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { SidepanelService } from './sidepanel.service';

@Component({
  selector: 'app-sidepanel-footer',
  imports: [HlmButtonImports],
  template: `<div class="flex justify-between">
    <button (click)="sidepanelCancel()" hlmBtn variant="secondary" type="button">Annuler</button>
    <button [disabled]="this.sidepanelService.loading()" (click)="sidepanelSubmit()" hlmBtn type="submit">
      Valider
    </button>
  </div>`,
})
export class SidepanelDefaultFooterComponent {
  readonly sidepanelService = inject(SidepanelService);

  sidepanelCancel() {
    this.sidepanelService.close();
  }

  sidepanelSubmit() {
    this.sidepanelService.onSubmit();
  }
}
